/**
 * TanStack Query hooks for location search.
 */
import { useQuery } from '@tanstack/react-query';
import { apiService } from '../services';
import { SEARCH_MIN_LENGTH } from '../constants';
import { unwrapServiceResultAsync } from '../services/utils/errorUtils';
import type { Location } from '../types';

export const LOCATIONS_QUERY_KEY = ['locations'] as const;
export const locationSearchQueryKey = (name: string) =>
  [...LOCATIONS_QUERY_KEY, 'search', name] as const;

export function useLocationSearchQuery(
  name: string,
  options?: { enabled?: boolean }
) {
  const trimmed = name.trim();
  return useQuery({
    queryKey: locationSearchQueryKey(trimmed),
    queryFn: () =>
      unwrapServiceResultAsync(
        apiService.locations.searchLocations(trimmed)
      ) as Promise<Location[]>,
    enabled: options?.enabled !== false && trimmed.length >= SEARCH_MIN_LENGTH,
  });
}
